import React from "react";
import { translate } from "./Translation";


export default class CollapsiblePanel extends React.Component {
	constructor(props) {
		super(props);

		this.display = "block";
		this.collapse_text = "Skryť";

		this.state = { expanded: this.props.expanded };
	}

	showHide() {
		this.setState({ expanded: !this.state.expanded });
	}

	render() {

		let footer = <div />;
		if (this.props.footer) {
			footer =
				<div className="panel-footer" style={{ display: (this.state.expanded ? "block" : "none") }}>{this.props.footer()}</div>;
		}

		return (
			<div className="panel panel-default">
				<div className="panel-heading">{this.props.title}
					<a className="btn btn-xs btn-primary pull-right"
						onClick={this.showHide.bind(this)}>{this.state.expanded ? translate("Skryť") : translate("Zobraziť")}</a>
				</div>
				<div className="panel-body" style={{ display: (this.state.expanded ? "block" : "none") }}>
					{this.props.children}
				</div>
				{footer}
			</div>
		)
	}

}


// WEBPACK FOOTER //
// ./src/modules/base/CollapsiblePanel.js